module.exports = __webpack_public_path__ + "static/media/4 devil neck tattoo dark art realism .1280x1707.5cd63a60.webp";